import React, { useState } from 'react';
import { Card, Row, Col } from 'antd';
import { HomeOutlined, InfoCircleOutlined, FileTextOutlined, EditOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

import Main from '../../components/layout/Main';
import { CombinedStates } from '../../core/types';
import HelpPradzia from './HelpPradzia';
import HelpMokykluPagrindineInformacija from './HelpMokykluPagrindineInformacija';
import HelpMokykluRodikliuPildymas from './HelpMokykluRodikliuPildymas';
import HelpMokykluRedagavimas from './HelpMokykluRedagavimas';
import HelpDefault from './HelpDefault';

import './help.scss';

type HelpMenuItem = {
    key: string;
    label: string;
    icon: React.ReactNode;
    component: React.ReactElement;
    roles?: number[];
};

const helpMenuItems: HelpMenuItem[] = [
    {
        key: 'pradzia',
        label: 'Pradžia',
        icon: <HomeOutlined />,
        component: <HelpPradzia />,
        roles: [1, 2, 3, 4, 5],
    },
    {
        key: 'mokyklu-pagrindine-informacija',
        label: 'Mokyklos darbalaukis',
        icon: <InfoCircleOutlined />,
        component: <HelpMokykluPagrindineInformacija />,
        roles: [1, 2, 3, 4, 5],
    },
    {
        key: 'mokyklu-redagavimas',
        label: 'Mokyklos informacijos redagavimas',
        icon: <EditOutlined />,
        component: <HelpMokykluRedagavimas />,
        roles: [1, 2, 3, 4, 5],
    },
    {
        key: 'mokyklu-rodikliu-pildymas',
        label: 'Mokyklų rodiklių pildymas',
        icon: <FileTextOutlined />,
        component: <HelpMokykluRodikliuPildymas />,
        roles: [1, 2, 3, 4, 5],
    },
];

const Help = () => {
    const toolbar = [{ label: 'Item 1', link: '/abc', iconName: 'home' }];
    const { userData } = useSelector((state: CombinedStates) => state.user);
    const [activeMenuKey, setActiveMenuKey] = useState<string>('pradzia');

    const filteredMenuItems = helpMenuItems.filter(
        item => !item.roles || item.roles.includes(userData?.role_id || 0),
    );

    const handleMenuClick = (key: string) => {
        setActiveMenuKey(key);
    };

    const renderContent = () => {
        const activeItem = helpMenuItems.find(item => item.key === activeMenuKey);
        return activeItem ? activeItem.component : <HelpDefault />;
    };

    return (
        <Main
            className="pagalba"
            title={<div>Pagalba</div>}
            headerTitle={<div>Pagalba</div>}
            menuWidth={350}
            menuPlacement="left"
            toolbar={toolbar}
            showFooter={false}
            floatingHeader={false}
            footerContent={<div />}
            floatingFooter
            backLink={false}
            breadcrumb={null}>
            <Row gutter={24} style={{ marginTop: '20px' }}>
                <Col span={5}>
                    <Card className="help-menu-card">
                        <nav className="help-menu" role="navigation" aria-label="Help navigation">
                            <ul className="help-menu__nav">
                                {filteredMenuItems.map((item) => {
                                    const isActive = activeMenuKey === item.key;
                                    return (
                                        <li key={item.key}>
                                            <button
                                                className={isActive ? 'active' : ''}
                                                onClick={() => handleMenuClick(item.key)}
                                                type="button"
                                                aria-label={`Navigate to ${item.label}`}
                                                tabIndex={0}>
                                                <span className="help-menu__nav-icon" aria-hidden="true">
                                                    {item.icon}
                                                </span>
                                                <span>{item.label}</span>
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </nav>
                    </Card>
                </Col>
                <Col span={19}>
                    <Card>
                        {renderContent()}
                    </Card>
                </Col>
            </Row>
        </Main>
    );
};

export default Help;

Help.propTypes = {};
